// src/components/ChangePasswordForm.js
import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Button, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { changePassword } from "../../../store/user/userThunk";
import { toast } from "react-toastify";

// Validation Schema
const ChangePasswordSchema = Yup.object().shape({
  currentPassword: Yup.string().required("Current password is required"),
  newPassword: Yup
    .string()
    .required('Please enter Password')
    .min(8, 'Password must be at least 8 characters')
    .max(32, 'Password must be at most 32 characters')
    .matches(/[a-z]/, 'Password must include at least one lowercase letter')
    .matches(/[A-Z]/, 'Password must include at least one uppercase letter')
    .matches(/\d/, 'Password must include at least one number')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must include at least one special character'),
  verifyPassword: Yup
    .string()
    .required('Please enter Password')
    .min(8, 'Password must be at least 8 characters')
    .max(32, 'Password must be at most 32 characters')
    .matches(/[a-z]/, 'Password must include at least one lowercase letter')
    .matches(/[A-Z]/, 'Password must include at least one uppercase letter')
    .matches(/\d/, 'Password must include at least one number')
    .matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must include at least one special character'),
});

const ChangePasswordForm = () => {
  let dispatch = useDispatch()
  const handleSubmit = (values, { resetForm }) => {
    console.log("Submitted values:", values);
    // TODO: Add your API logic here
    dispatch(changePassword({
      oldPassword: values?.currentPassword,
      newPassword: values?.newPassword
    })).unwrap().then((result) => {
      console.log(result ,"resultresultresultresultresult")
      if (result?.status===200) {
        toast.success(result.message)
      }
    }).catch((e) => {
      console.log(e, "err")
      toast.error(e)
    });
    resetForm();
  };

  return (
    <Card>
      <Card.Header className="d-flex justify-content-between">
        <div className="iq-header-title">
          <h4 className="card-title">Change Password</h4>
        </div>
      </Card.Header>
      <Card.Body>
        <Formik
          initialValues={{
            currentPassword: "",
            newPassword: "",
            verifyPassword: "",
          }}
          validationSchema={ChangePasswordSchema}
          onSubmit={handleSubmit}
        >
          {({ handleReset }) => (
            <Form>
              <div className="form-group">
                <label htmlFor="currentPassword" className="form-label">
                  Current Password:
                </label>
                <Link to="/auth/recover-password" className="float-end">
                  Forgot Password
                </Link>
                <Field
                  name="currentPassword"
                  type="password"
                  className="form-control"
                />
                <ErrorMessage
                  name="currentPassword"
                  component="div"
                  className="text-danger"
                />
              </div>

              <div className="form-group">
                <label htmlFor="newPassword" className="form-label">
                  New Password:
                </label>
                <Field
                  name="newPassword"
                  type="password"
                  className="form-control"
                />
                <ErrorMessage
                  name="newPassword"
                  component="div"
                  className="text-danger"
                />
              </div>

              <div className="form-group">
                <label htmlFor="verifyPassword" className="form-label">
                  Verify Password:
                </label>
                <Field
                  name="verifyPassword"
                  type="password"
                  className="form-control"
                />
                <ErrorMessage
                  name="verifyPassword"
                  component="div"
                  className="text-danger"
                />
              </div>

              <Button type="submit" className="btn btn-primary me-2">
                Submit
              </Button>
              <button
                type="button"
                className="btn btn-danger-subtle"
                onClick={handleReset}
              >
                Cancel
              </button>
            </Form>
          )}
        </Formik>
      </Card.Body>
    </Card>
  );
};

export default ChangePasswordForm;
